import AllApplicants from './AllApplicants.container';

export default AllApplicants;
